// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"cc0a8d51","787":"30654e42"}[chunkId] + ".chunk.js";
};